import { EventEmitter, Directive, Inject, Optional, Output, Input, HostListener, NgModule } from '@angular/core';
import { AlertsModuleConfigToken } from '@mt-ng2/alerts-module-config';
import { ModalService, ModalModule } from '@mt-ng2/modal-module';
import { CommonModule } from '@angular/common';

/**
 * [mtConfirm] directive binds to a custom output event that listens to and prevents the default click operation.
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@mt-ng2/modal-module';
class MtConfirmDirective {
    constructor(modalService, alertsConfig) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        this.modalService = modalService;
        this.alertsConfig = alertsConfig;
        /**
         * Emits when the user clicks "Confirm".
         * Bears a value when using "input", resolved "preConfirm", etc.
         *
         * @example
         * ```html
         * <button (mtConfirm)="delete()">Delete</button>
         * ```
         * ```typescript
         * public delete(): void {
         *     // delete logic
         * }
         * ```
         */
        this.mtConfirm = new EventEmitter();
        /**
         * Emits when the user clicks "Cancel" (or dismisses the modal by any other way).
         * By default, it will emit a string representing the reason for which the modal has been closed, or the
         * value of a rejected "preConfirm".
         *
         * @example
         * ```html
         * <button (mtConfirm)="delete()" (cancel)="canceled($event)">Delete</button>
         * ```
         * ```typescript
         * public canceled(reason: string): void {
         *     // reason can be 'cancel', 'overlay', 'close', and 'timer'
         * }
         * ```
         */
        this.cancel = new EventEmitter();
        /**
         * Pass in a modalOptions object that will override any of the default properties.
         *
         * @example
         * ```html
         * <button (mtConfirm)="delete()" [mtConfirmOptions]="confirmOptions">Delete</button>
         * ```
         * ```typescript
         * confirmOptions: IModalOptions = {
         *     confirmButtonText: 'Yes, delete it!',
         *     text: 'You wont be able to revert this!',
         *     title: 'Are you sure?',
         *     type: 'warning',
         * };
         * ```
         */
        this.mtConfirmOptions = {};
        /**
         * Holds the default modal options.
         */
        this.modalOptions = {
            cancelButtonClass: 'btn btn-swal-override',
            confirmButtonClass: 'btn btn-swal-override',
            confirmButtonText: (_c = (_b = (_a = this.alertsConfig) === null || _a === void 0 ? void 0 : _a.mtConfirmOptions) === null || _b === void 0 ? void 0 : _b.confirmButtonText) !== null && _c !== void 0 ? _c : 'Yes, delete it!',
            showCancelButton: true,
            text: (_f = (_e = (_d = this.alertsConfig) === null || _d === void 0 ? void 0 : _d.mtConfirmOptions) === null || _e === void 0 ? void 0 : _e.text) !== null && _f !== void 0 ? _f : 'You wont be able to revert this!',
            title: (_j = (_h = (_g = this.alertsConfig) === null || _g === void 0 ? void 0 : _g.mtConfirmOptions) === null || _h === void 0 ? void 0 : _h.title) !== null && _j !== void 0 ? _j : 'Are you sure?',
            type: (_m = (_l = (_k = this.alertsConfig) === null || _k === void 0 ? void 0 : _k.mtConfirmOptions) === null || _l === void 0 ? void 0 : _l.type) !== null && _m !== void 0 ? _m : 'warning',
        };
    }
    ngOnInit() {
        // override any of the passed in options vs the default options
        this.modalOptions = Object.assign(this.modalOptions, this.mtConfirmOptions);
    }
    onHostClicked(event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        event.stopPropagation();
        this.modalService.showModal(this.modalOptions).subscribe((result) => {
            if (result.value) {
                this.mtConfirm.emit(event);
            }
            else {
                this.cancel.emit(result.dismiss);
            }
        });
    }
}
MtConfirmDirective.ɵfac = function MtConfirmDirective_Factory(t) { return new (t || MtConfirmDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.ModalService), ɵngcc0.ɵɵdirectiveInject(AlertsModuleConfigToken, 8)); };
MtConfirmDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MtConfirmDirective, selectors: [["", "mtConfirm", ""]], hostBindings: function MtConfirmDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function MtConfirmDirective_click_HostBindingHandler($event) { return ctx.onHostClicked($event); });
    } }, inputs: { mtConfirmOptions: "mtConfirmOptions" }, outputs: { mtConfirm: "mtConfirm", cancel: "cancel" } });
MtConfirmDirective.ctorParameters = () => [
    { type: ModalService },
    { type: undefined, decorators: [{ type: Inject, args: [AlertsModuleConfigToken,] }, { type: Optional }] }
];
MtConfirmDirective.propDecorators = {
    mtConfirm: [{ type: Output }],
    cancel: [{ type: Output }],
    mtConfirmOptions: [{ type: Input }],
    onHostClicked: [{ type: HostListener, args: ['click', ['$event'],] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MtConfirmDirective, [{
        type: Directive,
        args: [{
                selector: '[mtConfirm]'
            }]
    }], function () { return [{ type: ɵngcc1.ModalService }, { type: undefined, decorators: [{
                type: Inject,
                args: [AlertsModuleConfigToken]
            }, {
                type: Optional
            }] }]; }, { mtConfirm: [{
            type: Output
        }], cancel: [{
            type: Output
        }], mtConfirmOptions: [{
            type: Input
        }], onHostClicked: [{
            type: HostListener,
            args: ['click', ['$event']]
        }] }); })();

class MtAlertsModule {
}
MtAlertsModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: MtAlertsModule });
MtAlertsModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function MtAlertsModule_Factory(t) { return new (t || MtAlertsModule)(); }, imports: [[CommonModule, ModalModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(MtAlertsModule, { declarations: function () { return [MtConfirmDirective]; }, imports: function () { return [CommonModule, ModalModule]; }, exports: function () { return [MtConfirmDirective]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MtAlertsModule, [{
        type: NgModule,
        args: [{
                declarations: [MtConfirmDirective],
                exports: [MtConfirmDirective],
                imports: [CommonModule, ModalModule]
            }]
    }], null, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { MtAlertsModule, MtConfirmDirective };

//# sourceMappingURL=mt-ng2-alerts-module.js.map